import * as modules from "./modules/";
import config from "../../../../config";
const { vendor } = config;

const TurtleStrategyTablePage = modules[vendor]
  ? modules[vendor]
  : modules["default"];

export default TurtleStrategyTablePage;
